import { combineReducers } from 'redux'

import { IHomeState } from '../interfaces'
import bannersReducer, { initialState as bannersInitialState } from './banners'
import faqReducer, { initialState as faqInitialState } from './faq'
import ratingsReducer, {
  initialState as ratingsInitialState,
} from './ratings/rateMyDelivery'
import rateMyServiceReducer, {
  initialServiceState as rateMyServiceInitialState,
} from './ratings/rateMyService'
import brandsReducer, { initialState as brandsInitialState } from './brands'

export const initialStates: IHomeState = {
  banners: bannersInitialState,
  faq: faqInitialState,
  ratings: ratingsInitialState,
  ratingService: rateMyServiceInitialState,
  brands: brandsInitialState,
}

export default combineReducers({
  banners: bannersReducer,
  faq: faqReducer,
  ratings: ratingsReducer,
  ratingService: rateMyServiceReducer,
  brands: brandsReducer,
})
